import { RuleTypeName } from '../rulebook';
import { MasterHelper } from '../../utilities';

export class LibraryFilterModel {
  Id: number | null;
  UserId: number | null;
  FromDate: string | null;
  ToDate: string | null;
  MappingID: string[] | null;
  Regulator: string[] | null;
  Geography: string[] | null;
  Country: string[] | null;
  RuleTypeName: RuleTypeName | null;
  Title: string[] | null;
  LinkedRules: string[] | null;

  SearchQuery: string[];
  SortKey: string | null;
  IsDesc: boolean | true;
  TakeCount: number | null;
  SkipCount: number | null;
  TotalItems: number | null;
  IsAdvance: boolean;

  constructor() {
    this.Id = null;
    this.UserId = null;
    this.FromDate = MasterHelper.getDateStr(30);
    this.ToDate = MasterHelper.getDateStr(0);
    this.MappingID = null;
    this.Regulator = null;
    this.Geography = null;
    this.Country = null;
    this.RuleTypeName = RuleTypeName.GDPR;
    this.Title = null;
    this.LinkedRules = null;

    this.SearchQuery = [];
    this.SortKey = null;
    this.IsDesc = true;
    this.TakeCount = null;
    this.SkipCount = null;
    this.TotalItems = null;
    this.IsAdvance = false;
  }
}
